import { API_ABOUTPAGE_DETAILS } from "../constants/api";
import {
  API,
  ABOUTPAGE_DETAILS_F,
  ABOUTPAGE_DETAILS_S,
} from "../constants/types";

export const renderAboutPageDetails = (showLoader = false) => ({
  type: API,
  payload: {
    url: API_ABOUTPAGE_DETAILS,
    method: "GET",
    showLoader,
    success: (data) => ({
      type: ABOUTPAGE_DETAILS_S,
      payload: data,
    }),
    error: (data) => ({
      type: ABOUTPAGE_DETAILS_F,
      payload: data,
    }),
  },
});
